import React, { use, useState } from 'react';
import { Card, Typography } from '@mui/material';
import './Homepage.css';
import Table  from './Table';
import { useEffect } from 'react';
const data = {
  headings: ['Particulars', 'Day1', 'Day2', 'Day3', 'Day4', 'Day5', 'Day6', 'Day7', 'Day8', 'Comments'],
  rows: [
    ['TotalNetSales', '25$', '25$', '150$', '250$', '120$', '458$', '950$', '25$', ''],
    ['TotalDiscountSales', '2550 $', '1500 $', '1253 $', '2887 $', '2343 $', '343 $', '345$', '342 $', ''],
    ['CashierOSAmount', '1552 $', '3245 $', '345 $', '435 $', '235 $', '345 $', '344 $', '34 $', ''],
    ['TotalEventOrdDuration', '3', '5', '5', '15', '4', '5', '45', '22', ''],
    ['TransCount', '250', '452', '255', '254', '482', '754', '187', '485', ''],
    ['AvgEventOrdDuration', '25', '12', '24', '23', '25', '24', '25', '24', ''],
   
  ],
};

const bgColors = [
  '#ffffff', '#ffffff', '#ffffff', '#ffffff',
  '#ffffff', '#ffffff', '#ffffff', '#ffffff',
  '#b2dfdb', '#ffffff'
];

export const Homepage = () => {
  console.log("Home Page API Calling ,,,,,,,");
  const [comments, setComments] = useState(data.rows.map(row => row[9] || ''));

  const handleCommentChange = (index, value) => {
    const updatedComments = [...comments];
    updatedComments[index] = value;
    setComments(updatedComments);
  };
  const email = sessionStorage.getItem("email");
  const fetchData = async () => {
     try{

      const resp = await fetch("/server/login-function/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await resp.json();

      const storedata = data.store

sessionStorage.setItem("store_id",storedata.store_id)
 }catch(err){
      console.log("error",err)
    }
    }
    
   
  useEffect( () => {
    
      
    fetchData();
  }, [email]);
  return (
    <div className='p-4 m-2'>
      {/* <form>
        <div className="flex flex-wrap gap-4">
          {data.headings.map((heading, colIdx) => (
            <Card
              key={heading}
              className={`flex flex-col p-2 ${
                colIdx === 9 ? 'flex-[2]' : colIdx === 0 ? 'flex-[1.5]' : 'flex-1'
              } min-w-[120px]`}
              style={{ backgroundColor: bgColors[colIdx % bgColors.length] }}
            >
              <Typography variant="subtitle2" className="mb-2 text-center text-xs md:text-sm font-semibold">
                {heading}
              </Typography>
              {data.rows.map((row, rowIdx) => (
                colIdx === 9 ? (
                  <textarea
                    key={rowIdx}
                    value={comments[rowIdx]}
                    onChange={(e) => handleCommentChange(rowIdx, e.target.value)}
                    className="w-full mb-2 p-1 border border-gray-300 rounded text-xs"
                    rows={2}
                  />
                ) : (
                  <Typography
                    key={rowIdx}
                    className="text-[11px] md:text-[10px] text-center border-t border-gray-200 py-1 h-[20%]"
                  >
                    {row[colIdx]}
                  </Typography>
                )
              ))}
            </Card>
          ))}
        </div>

        <div className="mt-5 flex justify-end">
          <button className="btnhome bg-green-700 text-white px-4 py-2 rounded hover:bg-green-800">
            Submit
          </button>
        </div>
      </form> */}


      <Table/>
    </div>
  );
};
